import React from "react";

const Vector = () => (
  <svg width="318px" height="280px" viewBox="0 0 318 280" version="1.1">
    <g
      id="Davos_Frame_09"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      transform="translate(-801.000000, -400.000000)"
      stroke-linecap="round"
    >
      <g
        id="Transformational-tools-icon"
        transform="translate(802.000000, 401.000000)"
        stroke-width="2"
      >
        <path
          d="M301.39,214.82 L297.6,214.82"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M309.825,214.82 L306.55,214.82"
          id="Shape"
          stroke="#00D5C1"
          opacity="0.8"
        />
        <path
          d="M301.39,203.27 L286.225,203.27"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M314.12,203.27 L306.55,203.27"
          id="Shape"
          stroke="#00D5C1"
          opacity="0.8"
        />
        <path
          d="M297.795,191.715 L274.66,191.715"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M314.265,191.715 L302.955,191.715"
          id="Shape"
          stroke="#00D5C1"
          opacity="0.8"
        />
        <path
          d="M290.595,178.615 L264.595,178.615"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M310.745,178.615 L295.76,178.615"
          id="Shape"
          stroke="#00D5C1"
          opacity="0.8"
        />
        <path
          d="M283.4,165.505 L260.445,165.505"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M301.6,165.505 L288.56,165.505"
          id="Shape"
          stroke="#00D5C1"
          opacity="0.8"
        />
        <path
          d="M272.61,151.63 L263.37,151.63"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M288.305,151.63 L277.77,151.63"
          id="Shape"
          stroke="#00D5C1"
          opacity="0.8"
        />
        <path
          d="M301.67,50.485 L298.52,50.485"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M309.155,50.485 L306.01,50.485"
          id="Shape"
          stroke="#FFAF3E"
          opacity="0.8"
        />
        <path
          d="M301.67,38.93 L287.185,38.93"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M313.86,38.93 L306.83,38.93"
          id="Shape"
          stroke="#FFAF3E"
          opacity="0.8"
        />
        <path
          d="M298.07,27.38 L275.735,27.38"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M314.54,27.38 L303.23,27.38"
          id="Shape"
          stroke="#FFAF3E"
          opacity="0.8"
        />
        <path
          d="M290.875,14.28 L265.61,14.28"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M311.025,14.28 L296.035,14.28"
          id="Shape"
          stroke="#FFAF3E"
          opacity="0.8"
        />
        <path
          d="M301.39,64.55 L297.055,64.55"
          id="Shape"
          stroke="#FFAF3E"
          opacity="0.8"
        />
        <path
          d="M309.325,64.55 L304.99,64.55"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M301.39,76.1 L282.82,76.1"
          id="Shape"
          stroke="#FFAF3E"
          opacity="0.8"
        />
        <path
          d="M314.195,76.1 L306.55,76.1"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M297.795,87.65 L270.045,87.65"
          id="Shape"
          stroke="#FFAF3E"
          opacity="0.8"
        />
        <path
          d="M314.265,87.65 L302.955,87.65"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M290.595,100.755 L262.15,100.755"
          id="Shape"
          stroke="#FFAF3E"
          opacity="0.8"
        />
        <path
          d="M310.745,100.755 L295.76,100.755"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M283.4,113.865 L260.595,113.865"
          id="Shape"
          stroke="#FFAF3E"
          opacity="0.8"
        />
        <path
          d="M301.6,113.865 L288.56,113.865"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M272.61,127.735 L266.555,127.735"
          id="Shape"
          stroke="#FFAF3E"
          opacity="0.8"
        />
        <path
          d="M285.78,127.735 L277.77,127.735"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M301.39,229.66 L297.6,229.66"
          id="Shape"
          stroke="#00D5C1"
          opacity="0.8"
        />
        <path
          d="M309.06,229.66 L306.55,229.66"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M301.39,241.21 L283.31,241.21"
          id="Shape"
          stroke="#00D5C1"
          opacity="0.8"
        />
        <path
          d="M313.75,241.21 L306.55,241.21"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M297.795,252.765 L270.395,252.765"
          id="Shape"
          stroke="#00D5C1"
          opacity="0.8"
        />
        <path
          d="M314.265,252.765 L302.955,252.765"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M290.595,265.865 L262.28,265.865"
          id="Shape"
          stroke="#00D5C1"
          opacity="0.8"
        />
        <path
          d="M310.745,265.865 L295.76,265.865"
          id="Shape"
          stroke="#FFFFFF"
          opacity="0.8"
        />
        <path
          d="M304,277.05 C309.65,270.515 313.825,262.825 314.805,252.815 C314.945,251.345 315.02,249.815 315.02,248.255 C315.02,233.435 302.855,220.025 291.45,208.62 C291.21,208.38 290.95,208.145 290.72,207.9 L285.59,202.765 L281.775,199.065 C281.665,198.96 281.555,198.845 281.455,198.74 C271.385,188.675 260.455,176.81 260.455,165.505"
          id="Shape"
          stroke="#FFFFFF"
          stroke-linejoin="round"
        />
        <path
          d="M273.905,136.925 C276.345,139.63 278.905,142.26 281.435,144.775 L281.755,145.1 L285.57,148.795 L290.7,153.935 C290.94,154.175 291.2,154.41 291.43,154.655 C302.835,166.06 315,179.465 315,194.285 C315,216.385 300.315,227.885 286.11,239.01 C272.91,249.355 260.445,259.13 260.445,277.045"
          id="Shape"
          stroke="#00D5C1"
        />
        <path
          d="M260.445,111.535 C260.445,120.035 266.59,128.81 273.905,136.925"
          id="Shape"
          stroke="#FFAF3E"
        />
        <path
          d="M274.655,136.95 C266.5,144.5 260.445,153 260.445,165.5"
          id="Shape"
          stroke="#FFFFFF"
          stroke-linejoin="round"
        />
        <path
          d="M260.445,0 C260.445,11.305 271.365,23.17 281.445,33.235 C281.545,33.345 281.655,33.455 281.765,33.56 L285.58,37.26 L290.7,42.405 L291.43,43.12 C302.835,54.525 315,67.935 315,82.755 C315,104.855 300.315,116.355 286.11,127.48 C282.11,130.61 278.19,133.685 274.655,136.95"
          id="Shape"
          stroke="#FFFFFF"
          stroke-linejoin="round"
        />
        <path
          d="M301.6,0 C309.065,8.77 315,18.435 315,28.785 C315,50.885 300.315,62.385 286.11,73.51 C272.91,83.855 260.445,93.63 260.445,111.55"
          id="Shape"
          stroke="#FFAF3E"
        />
        <polyline
          id="Shape"
          stroke="#FFAF3E"
          points="179.805 256.23 167.665 210.61 167.665 180.005 127.965 157.1"
        />
        <polyline
          id="Shape"
          stroke="#FFAF3E"
          points="45.72 256.23 57.86 210.61 57.86 180.005 97.56 157.1"
        />
        <polyline
          id="Shape"
          stroke="#FFAF3E"
          points="167.665 277.05 149.99 210.61 149.93 210.32 149.93 187.515 127.965 174.845"
        />
        <polyline
          id="Shape"
          stroke="#FFAF3E"
          points="57.86 277.05 75.535 210.61 75.595 210.32 75.595 187.515 97.56 174.845"
        />
        <rect
          id="Rectangle-path"
          stroke="#FFAF3E"
          fill="#1A1C35"
          fill-rule="nonzero"
          x="97.56"
          y="81.09"
          width="30.41"
          height="67.575"
          rx="15.205"
        />
        <rect
          id="Rectangle-path"
          stroke="#FFAF3E"
          fill="#1A1C35"
          fill-rule="nonzero"
          x="90.8"
          y="132.61"
          width="43.92"
          height="65.885"
          rx="21.96"
        />
        <circle
          id="Oval"
          stroke="#FFAF3E"
          fill="#1A1C35"
          fill-rule="nonzero"
          cx="112.76"
          cy="69.26"
          r="11.825"
        />
        <path
          d="M112.76,57.435 L112.76,0"
          id="Shape"
          stroke="#FFAF3E"
          fill="#1A1C35"
          fill-rule="nonzero"
        />
        <polyline
          id="Shape"
          stroke="#FFAF3E"
          points="60.59 42.46 75.595 51.385 75.595 83.48 97.56 96.29"
        />
        <polyline
          id="Shape"
          stroke="#FFAF3E"
          points="164.935 42.46 149.93 51.385 149.93 83.48 127.965 96.29"
        />
        <path
          d="M9.645,115.22 C-3.18197476,128.085594 -3.166325,148.908728 9.6799737,161.755026 C22.5262724,174.601325 43.3494064,174.616975 56.215,161.79 L112.43,105.574974 L32.93,105.575 C24.194237,105.563989 15.8143146,109.03508 9.645,115.22 Z"
          id="wing-1"
          stroke="#FFAF3E"
          fill="#1A1C35"
          fill-rule="nonzero"
          stroke-linejoin="round"
        />
        <path
          d="M215.215,115.22 C228.041975,128.085594 228.026325,148.908728 215.180026,161.755026 C202.333728,174.601325 181.510594,174.616975 168.645,161.79 L112.43,105.574971 L191.93,105.575 C200.665873,105.563436 209.045999,109.034611 215.215,115.22 Z"
          id="wing-2"
          stroke="#FFAF3E"
          fill="#1A1C35"
          fill-rule="nonzero"
          stroke-linejoin="round"
        />
      </g>
    </g>
  </svg>
);

export default Vector;



// WEBPACK FOOTER //
// ./src/components/tools/vector.js